import React from "react"
import PropTypes from "prop-types"
import { Menu, Form, Button, Input, Icon } from "semantic-ui-react"
import { withTranslation } from "react-i18next"

// TODO: refactor pagination
class Pagination extends React.Component {
  state = {
    value: "",
  }
  // constructor(props) {
  //   super(props)
  //   this.selectPage
  //   = ::this.selectPage
  //   this.selectNext = ::this.selectNext
  //   this.selectPrevious = ::this.selectPrevious
  // }

  selectNext = () => {
    const { count, current, onSelect } = this.props
    if (current < count) {
      onSelect(current + 1)
    }
  }

  selectPrevious = () => {
    const { current, onSelect } = this.props
    if (current > 1) {
      onSelect(current - 1)
    }
  }

  // eslint-disable-next-line no-empty-pattern
  selectPage = ({}, { data }) => {
    const { current, onSelect } = this.props
    if (data !== current) {
      onSelect(data)
    }
  }

  select = () => {
    const { value } = this.state
    const { onSelect } = this.props
    onSelect(Number(value))
  }

  handleChange = ({ target: { value } }) => {
    if (!value || value.match(/^\d{1,}(\.\d{0,4})?$/)) {
      this.setState({ value })
    }
  }

  getItems() {
    const { count, max, current } = this.props
    let newMax = count - max > 1 ? max : count
    const start = current - max < 0 ? 1 : current - max + 2
    const items = [
      <Menu.Item
        className="menu-item-pagination"
        key="prev"
        content="<"
        disabled={current === 1}
        onClick={this.selectPrevious}
      />,
    ]
    if (max <= count ? newMax <= current : null) {
      items.push(
        <Menu.Item
          className="menu-item-pagination"
          key={count + 1}
          data={1}
          content={1}
          onClick={this.selectPage}
        />,
      )
      items.push(
        <Menu.Item
          className="menu-item-pagination"
          key="firstempty"
          content="..."
          disabled
        />,
      )
    }

    for (let i = start; i < newMax + start && i <= count; i++) {
      items.push(
        <Menu.Item
          className="menu-item-pagination"
          data={i}
          key={i}
          content={i.toString()}
          active={current === i}
          onClick={this.selectPage}
        />,
      )
    }

    if (newMax + start <= count) {
      items.push(
        <Menu.Item
          className="menu-item-pagination"
          key="empty"
          content="..."
          disabled
        />,
      )
      items.push(
        <Menu.Item
          className="menu-item-pagination"
          key={count}
          data={count}
          content={count}
          onClick={this.selectPage}
        />,
      )
    }
    items.push(
      <Menu.Item
        key="next"
        disabled={current === count}
        content=">"
        onClick={this.selectNext}
      />,
    )
    // if (newMax + start <= count) {
    //   items.push(
    //     <Menu.Item
    //       key={count}
    //       data={count}
    //       content={count}
    //       onClick={this.selectPage}
    //     />,
    //   )
    // }
    return items
  }

  render() {
    const { t } = this.props
    const { value } = this.state
    return (
      <div>
        <Menu pagination>{this.getItems()}</Menu>

        <Input>
          <input
            style={{ borderRadius: 0, maxWidth: "70px" }}
            placeholder={`№  ${t("pageWord")}`}
            onChange={this.handleChange}
            value={value}
            type="text"
          />
          <Button style={{ borderRadius: 0 }} positive onClick={this.select}>
            <Icon style={{ margin: 0 }} name="search" />
          </Button>
        </Input>
      </div>
    )
  }
}

Pagination.propTypes = {
  max: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default withTranslation()(Pagination)

/* 
import React, { useState } from "react"
import PropTypes from "prop-types"
import { Menu, Form, Button, Input, Icon } from "semantic-ui-react"
import { withTranslation, useTranslation } from "react-i18next"

const Pagination = (props) => {
  const [value, setValue] = useState("")

  selectNext = () => {
    const { count, current, onSelect } = props
    if (current < count) {
      onSelect(current + 1)
    }
  }

  selectPrevious = () => {
    const { current, onSelect } = props
    if (current > 1) {
      onSelect(current - 1)
    }
  }

  selectPage = ({}, { data }) => {
    const { current, onSelect } = props
    if (data !== current) {
      onSelect(data)
    }
  }

  select = () => {
    const { onSelect } = props
    onSelect(Number(value))
  }

  handleChange = ({ target: { value } }) => {
    if (!value || value.match(/^\d{1,}(\.\d{0,4})?$/)) {
      setValue({ value })
    }
  }

      const selectPage = ::selectPage
//   //   this.selectNext = ::this.selectNext
//   //   this.selectPrevious = ::this.selectPrevious

  const getItems = () => {
    const { count, max, current } = props
    let newMax = count - max > 1 ? max : count
    const start = current - max < 0 ? 1 : current - max + 2
    const items = [
      <Menu.Item
        className="menu-item-pagination"
        key="prev"
        content="<"
        disabled={current === 1}
        onClick={selectPrevious}
      />,
    ]
    if (max <= count ? newMax <= current : null) {
      items.push(
        <Menu.Item
          className="menu-item-pagination"
          key={count + 1}
          data={1}
          content={1}
          onClick={selectPage}
        />,
      )
      items.push(
        <Menu.Item
          className="menu-item-pagination"
          key="firstempty"
          content="..."
          disabled
        />,
      )
    }

    for (let i = start; i < newMax + start && i <= count; i++) {
      items.push(
        <Menu.Item
          className="menu-item-pagination"
          data={i}
          key={i}
          content={i.toString()}
          active={current === i}
          onClick={selectPage}
        />,
      )
    }

    if (newMax + start <= count) {
      items.push(
        <Menu.Item
          className="menu-item-pagination"
          key="empty"
          content="..."
          disabled
        />,
      )
      items.push(
        <Menu.Item
          className="menu-item-pagination"
          key={count}
          data={count}
          content={count}
          onClick={selectPage}
        />,
      )
    }
    items.push(
      <Menu.Item
        key="next"
        disabled={current === count}
        content=">"
        onClick={selectNext}
      />,
    )
    // if (newMax + start <= count) {
    //   items.push(
    //     <Menu.Item
    //       key={count}
    //       data={count}
    //       content={count}
    //       onClick={this.selectPage}
    //     />,
    //   )
    // }

    return items
  }

  const { t } = useTranslation()
  return (
    <div>
      <Menu pagination>{getItems()}</Menu>

      <Input>
        <input
          style={{ borderRadius: 0, maxWidth: "70px" }}
          placeholder={`№  ${t("pageWord")}`}
          onChange={handleChange}
          value={value}
          type="text"
        />
        <Button style={{ borderRadius: 0 }} positive onClick={select}>
          <Icon style={{ margin: 0 }} name="search" />
        </Button>
      </Input>
    </div>
  )
}

// // TODO: refactor pagination
//   // constructor(props) {
//   //   super(props)


Pagination.propTypes = {
  max: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default Pagination


*/
